import { render, staticRenderFns } from "./InvestmentPlansMainPageV2.vue?vue&type=template&id=5c2517de&"
import script from "./InvestmentPlansMainPageV2.vue?vue&type=script&lang=js&"
export * from "./InvestmentPlansMainPageV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports